<template>
  <div class="detail-list-item">
    <div class="title">
      <strong style="white-space: nowrap;">{{ title }}</strong>
      <span v-if="asside">(<em>{{ asside }}</em>)</span>
    </div>
    <div v-if="alt">{{ alt }}</div>
    <div v-if="figureName">{{ figureName }}</div>
  </div>
</template>

<script>
import Names from "../utils/names";

export default {
  name: "DetailListItem",
  props: {
    title: String,
    figureIndex: Number,
    alt: String,
    asside: String
  },
  computed: {
    figureName() {
      if (this.figureIndex) {
        return Names.getNameForFigure(
          this.$store.getters.getNovenaryFigureById(this.figureIndex)
        );
      } else {
        return "";
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.detail-list-item {
  display: flex;
  justify-content: space-between;
}

.title {
  padding-right: 1rem;
  display: flex;
  align-items: center;
}
</style>
